

import { createApp } from 'vue'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import store from './store/index'
import Vue3Signature from "vue3-signature"
import VueExcelEditor from 'vue3-excel-editor'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VPie } from 'vuetify/labs/VPie'
import vue3ToPdf from 'vue3-to-pdf'
// import PrimeVue from 'primevue/config';
// import Toast from 'primevue/toast';
// import ToastService from 'primevue/toastservice';
import i18n from './i18n'

import App from './App.vue'
import router  from './router/index'


const vuetify = createVuetify({
  components
  // : {
  //   VPie,
  // }
  ,
  directives,
 
})


const app=createApp(App)

app.use(vuetify)
app.use(store)
app.use(router)
app.use(Vue3Signature)
app.use(VueExcelEditor)
app.use(vue3ToPdf)
app.use(i18n) 
// app.use(PrimeVue);
// app.use(ToastService);
// app.use(Toast);
app.mount('#app')
